import { useState, useEffect } from "react"
import { Container, Typography, TextField } from "@mui/material"
import { Wrapper, InputWrapper } from '../style'
import {useLocation, useNavigate} from "react-router-dom"
import loginSchema from '../../../validation/login'
import validate from "../../../validation"
import axios from 'axios'
import { baseURL } from "../../../functions/baseUrl"
import toEnglishDigits from '../../../functions/toEnglishDigits'
import customAxios from '../../../functions/requestInterceptor'
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import NoticeModal from '../../dashboard/dashboard/notice'
// import Box from '@mui/material/Box';
// import MenuItem from '@mui/material/MenuItem';
// import Select from '@mui/material/Select';
// import LanguageIcon from '@mui/icons-material/Language';

function Login () {
  const navigate = useNavigate()
  const location = useLocation()
  const { t , i18n} = useTranslation('translation', { keyPrefix: 'auth' });

  useEffect(() => {
    customAxios.get('/tickets/list', {})
     .then(() => {
       navigate('/')
     })
     .catch((error) => {
       console.log(error)
     })
  }, [])

  const [name, setName] = useState('');
  useEffect(() => {
    axios.get(`${baseURL}/metadata/`)
    .then((response) => {
      setName(response.data.data.website_title)
    })
    .catch(() => {
      console.log('error')
    });
  }, [])

  const [mobile, setMobile] = useState('')
  const [error, setError] = useState({})

  const handleChange = (e) => {
    const newValue = toEnglishDigits(e.target.value)
    setError({})
    setMobile(newValue)
  }

  const validationData = () => {
    const params = {
      mobile
    }
    const constrains = loginSchema()
    const hasError = false
    let err = {}
    const keys = Object.keys(params)
    for (let i = 0; i < keys.length; i++) {
      const errorMessage = validate(params, keys[i], constrains)
      err = { ...err, [keys[i]]: errorMessage }
      if (errorMessage) {
        setError({ ...err })
        return true
      }
    }
    setError({ ...err })
    return hasError
  }

  const [loading, setLoading] = useState(false)
  const getOtp = () => {
    setLoading(true)
    axios.post(baseURL + '/otp/', {
      mobile_number: mobile
    })
    .then((response) => {
      if(response.status === 201) {
        navigate('/sign-up', {
          replace: true,
          state: {
            mobile,
            next: location.state?.next
        }})
      } else {
        navigate('/verification', {state: {mobile, next: location.state?.next}})
      }
    })
    .catch((error) => {
      setLoading(false)
      console.log(error)
      if (error?.response?.status === 429) {
        setError({serverError: 'خطای درخواست زیاد، لطفا چند دقیقه بعد تلاش کنید.'})
      } else {
        setError({serverError: error?.response?.data?.detail || t('server_error')})
      }
    });
  }

  function handleClick () {
    const hasError = validationData()
    if (!hasError) {
      // empty error object
      setError({})
      // submit data
      getOtp()
    }
  }

  // const handleChangeLang = (event) => {
  //   i18n.changeLanguage(event.target.value)
  // };

  const [openNoticeModal, setNoticeModal] = useState(false);
  const [notice, setNotice] = useState('');
  useEffect(() => {
    const meta = JSON.parse(localStorage.getItem('metadata'))

    if (meta?.notice) {
      setNotice(meta.notice)
      setNoticeModal(true)
    }
  }, [])

  const handleCloseNoticeModal = () => {
    setNoticeModal(false)
  }

  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  return (
    <Container maxWidth='xs' dir={direction}>
      <Typography variant="h5" component="h5" align="center" sx={{marginBottom: '20px'}}>
        {name}
      </Typography>
      <Wrapper>

        {/*<Box sx={{display: 'flex', alignItems: 'center', gap: '4px'}}>*/}
        {/*  <LanguageIcon style={{color: 'gray'}} />*/}
        {/*  <Select*/}
        {/*   label="Language"*/}
        {/*   size={'small'}*/}
        {/*   onChange={handleChangeLang}*/}
        {/*   value={i18n.language}*/}
        {/*  >*/}
        {/*    <MenuItem value={'fa'}>فارسی</MenuItem>*/}
        {/*    <MenuItem value={'en'}>English</MenuItem>*/}
        {/*  </Select>*/}
        {/*</Box>*/}

        <Typography variant="h6" component="h6" align="center">
          {t('login_or_signup')}
        </Typography>
        <Typography variant="caption" component="span" align="center">
          {t('enter_mobile_number')}
        </Typography>
        <InputWrapper>
          <span>
          {t('mobile')}
          </span>
          <TextField
            error={error.mobile}
            label=''
            defaultValue=""
            size="small"
            onChange={handleChange}
            placeholder={t('mobile_placeholder')}
            inputProps={{
              pattern: "[0-9]*",
              inputMode: 'numeric'
            }}
          />
        </InputWrapper>
        {!!error.mobile &&
          <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
            {error.mobile}
          </Typography>
        }
        <LoadingButton
          variant="contained"
          onClick={handleClick}
          loading={loading}
         loadingPosition="start"
        >
          {t('continue')}
        </LoadingButton>
        {!!error.serverError &&
          <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
            {error.serverError}
          </Typography>
        }
        <Typography
          variant="caption"
          component="span"
          align="center"
          sx={{cursor: 'pointer'}}
          onClick={() => navigate('/faq')}
        >
          {t('faq')}
        </Typography>
        <NoticeModal
          open={openNoticeModal}
          handleClose={handleCloseNoticeModal}
          content={notice}
          backgroundColor='#ede25e'
        />
      </Wrapper>
    </Container>
  )

}

export default Login
